<script setup>
import DuplicateResumeProfilChoice from '@/components/popup/DuplicateResumePopup/DuplicateResumeProfilChoice.vue';
import { ref } from 'vue';
import DuplicationForm from '@/components/popup/DuplicateResumePopup/DuplicationForm.vue';

const isNewProfile = ref(false);
const currentStep = ref(0);

const updateCurrentStep = isNewProfileValue => {
  isNewProfile.value = isNewProfileValue;
  currentStep.value = 1;
};
</script>

<template>
  <div class="header">
    <div class="title ellipsis">{{ $t('popUp.duplicateResume.title') }}</div>
  </div>
  <DuplicateResumeProfilChoice v-if="!currentStep" @move="isNewProfileValue => updateCurrentStep(isNewProfileValue)" />
  <DuplicationForm v-else :is-new-profile="isNewProfile" @back="currentStep = 0" />
</template>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/inputs.scss';
@use '@/styles/buttons.scss';

.header {
  border-bottom: 1px solid colors.$light-blue-color;
  width: 100%;

  .title {
    padding-bottom: 22px;
    color: colors.$light-blue-color;
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
  }
}
</style>
